import { css } from "@emotion/react";

export const header = css`
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 0 15px;
  gap: 15px;
`;
